import { Plus } from "lucide-react";
import { SaudiRiyal } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const ProductCard = ({ product, isLast, isOffer }) => {
  const navigate = useNavigate();

  const onItemClick = (product) => {
    navigate(`/meal/${product.id}`);
  };

  const isAllSizesOutOfStock = (product) => {
    if (!product?.product_variations || product.product_variations.length === 0)
      return false;

    const allVariations = product.product_variations.flatMap(
      (pv) => pv?.variations || [],
    );

    return allVariations.every((variation) => {
      const details = variation?.variation_location_details;

      if (!details || details.length === 0) return true;

      return details[0]?.in_stock === false || details[0]?.qty_available === 0;
    });
  };

  const firstVariation = product.product_variations?.[0]?.variations || [];

  const firstInStockVariation = firstVariation.find(
    (v) => v?.variation_location_details?.[0]?.in_stock === true,
  );

  const fallbackVariation = firstVariation[0];

  const outOfStock = isAllSizesOutOfStock(product);

  const hasDetails =
    product.product_variations?.[0]?.variations?.[0]
      ?.variation_location_details;

  const isUnavailable = isOffer
    ? false
    : Number(product.is_inactive) === 1 ||
      !hasDetails ||
      hasDetails.length === 0;

  const finalPrice =
    firstInStockVariation?.discount?.final_price ||
    fallbackVariation?.discount?.final_price;

  const showPriceBefore =
    firstInStockVariation?.discount?.discount_value !== "0";

  const quantities = (product.cart || [])
    .filter((p) => p.product.id === product.id)
    .map((p) => p.quantity);

  const quantity = quantities.reduce((acc, q) => acc + q, 0);

  // console.log({
  //   id: product.id,
  //   is_inactive: product.is_inactive,
  //   outOfStock,
  //   hasDetails:
  //     product.product_variations?.[0]?.variations?.[0]
  //       ?.variation_location_details,
  // });

  return (
    <div
      className={isUnavailable ? `product-notVisible` : `product`}
      onClick={() => {
        if (!isUnavailable) onItemClick(product);
      }}
      style={{
        border: product.cart.length > 0 && "1px solid #4faf5a",
        marginBottom: isLast ? "0" : "10px",
      }}
    >
      <div className="container-content">
        <img src={product.image} alt={product.name} />
        <div className="content">
          <div className="text">
            <h3
              style={{
                color: isUnavailable ? "#999" : "#000",
              }}
            >
              {product.name}
            </h3>
            <p className={isUnavailable ? `is-visible` : `is-not-visible`}>
              (غير متاح)
            </p>
          </div>
          <div className="price">
            <span
              style={{
                color: isUnavailable ? "#999" : "#4faf5a",
                fontWeight: "bold",
              }}
            >
              {finalPrice}
              <SaudiRiyal size={18} />
            </span>
          </div>

          {!isUnavailable && product.badge !== null && (
            <p
              className="product-badge"
              style={{
                backgroundColor: `${product.badge.background_color}`,
                color: `${product.badge.name_color}`,
              }}
            >
              {product.badge.name}
            </p>
          )}
        </div>
      </div>

      <div className={isUnavailable ? `is-not-visible` : `product-btn`}>
        <div style={{ fontWeight: "bold", margin: "0 12px 5px 0" }}>
          {quantity > 0 && quantity}
        </div>
        <button>
          <Plus size={15} />
        </button>
      </div>
    </div>
  );
};
